
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M71.2 70.26H16.52A10.54 10.54 0 016 59.73V28.22a10.54 10.54 0 0110.52-10.53H71.2a10.54 10.54 0 0110.52 10.53v31.51A10.54 10.54 0 0171.2 70.26zM16.52 22.69A5.53 5.53 0 0011 28.22v31.51a5.53 5.53 0 005.52 5.53H71.2a5.53 5.53 0 005.52-5.53V28.22a5.53 5.53 0 00-5.52-5.53z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    